(ns bp-clients.tv-app.nav.views.error-page
  "Namespace for login page view for when user is logged-out"
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.common.events :as common-events]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-clients.tv-app.nav.subs :as nav-subs]
   [bp-clients.tv-app.nav.views.network :refer [network-modal]]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def ^:private errors
  {:not-found  {:title "Conteúdo não encontrado"
                :message "O conteúdo não existe ou está temporariamente indisponível."}
   :unexpected {:title "Erro inesperado"
                :message "Seu aparelho pode não estar conectado a Internet. Por favor, confirme que sua internet está funcionando."}
   :playback   {:title "Erro ao reproduzir"
                :message ""}
   :connection {:title "Erro de conexão"
                :message ""}})

(defn error-page
  "Error page.
  We handle a set of error types:

  - Not found
  - Unexpected error
  - Connection error
  - Playback error

  All these have different messages and
  (maybe) different actions that the
  user can do."
  [error-queue]
  (r/create-class
   (let [main-focus-ref (createRef)]
     {:component-did-mount (fn [_react-component]
                             (when-let [main-button main-focus-ref.current]
                               (.focus main-button)))
      :reagent-render (fn [_props]
                        (let [error-type       (-> error-queue first :type)
                              error-data       (get errors error-type)
                              network-offline? @(rf/subscribe [::nav-subs/network-offline?])]
                          (if network-offline?
                            [network-modal {:react-ref main-focus-ref}]

                            [:main {:class "flex min-h-screen w-full bg-black text-white overflow-hidden overscroll-contain"}
                             [:div {:class "w-full flex flex-col items-center justify-center space-y-6"}
                              [:h1 {:class "text-3xl font-bold"}
                               (:title error-data)]
                              [:p {:class "w-96 text-center font-medium"}
                               (:message error-data)]
                              [:div {:class "flex space-x-4 text-sm"}
                               [Button {:extra-classes ["px-4 outline-none"]
                                        :tab-index     10
                                        :color         "black"
                                        :react-ref     main-focus-ref
                                        :on-click      #(rf/dispatch [::common-events/process-error-queue])}
                                "Tentar novamente"]
                               [Button {:color         "black"
                                        :tab-index     10
                                        :extra-classes ["px-4 outline-none"]
                                        :on-click      #(rf/dispatch [::nav-events/navigate-back])}
                                "Voltar"]]]])))})))
